



























import ExtraButton from '@/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButton.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';
import AppSvgIconNew from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
import isAuthorized from '@/mixins/isAuthorized';
import Accessibility from '@/uikit/mixins/accessibility';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import ConsultationsModal from '@/components/ordersProcessForms/consultation/ConsultationsModal.vue';
import { blockByNewPdpConsent } from '@/tools/newPdpConsentGuard';

export default {
  name: 'ExtraButtons',
  components: { AppButtonNew, AppSvgIcon, ExtraButton, AppSvgIconNew },
  mixins: [isAuthorized, Accessibility],
  computed: {
    hasApiModuleConsultations() {
      return this.$store.getters.hasApiModuleConsultations;
    },
  },
  methods: {
    openModal() {
      if (blockByNewPdpConsent(this.$store, this.openModal.bind(this))) return;
      this.$ui.$modal.show('ConsultationModal', {
        settings: {
          size: {
            width: '500px',
            minHeight: '300px',
            height: '535px',
          },
          title: 'Добавить новую консультацию',
        },
        bind: this,
        slots: {
          body: {
            component: ConsultationsModal,
            propsData: {
              isError: this.isError,
            },
          },
        },
      });
    },
    openMenu() {
      this.$store.commit('setMenuStatus', true);
    },
    register() {
      if (this.isAuthorized) {
        window.location.assign('/profile/education/schedule/week');
      } else {
        window.location.assign('/?modal=auth#signin');
      }
    },
    toggleSearch() {
      this.$store.state.menuPanel.search = !this.$store.state.menuPanel.search;
      this.$store.state.menuPanel.menuOpen =
        !this.$store.state.menuPanel.menuOpen;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButtons.vue